<mat-sidenav-container class="sidenav-container" layout="column" flex>
    <mat-sidenav
        #drawer
        mode="over"
        position="end"
        class="sidenav"
        [fixedInViewport]="true"
    >
        <div fxLayout="column" fxFlex>
            <div class="sidenav-header">
                <h1 class="sidenav-title">Navegar</h1>
                <dsn-button-rounded
                    [type]="'secondary'"
                    [icon]="'fa-solid fa-xmark'"
                    [size]="'medium'"
                    (click)="toggleDrawer()"
                ></dsn-button-rounded>
            </div>
            <div class="horizontal-divider"></div>
            <div fxLayout="column" fxFlex>
                @defer (when !loading) {
                    <app-report-dashboard-sidenav-list
                        class="full-height"
                        [report]="report"
                        (onNavigate)="handleNavigation($event)"
                    ></app-report-dashboard-sidenav-list>
                }
            </div>
        </div>
    </mat-sidenav>

    <mat-sidenav-content
        fxFlex
        id="ReportPreviewScroll"
        #ReportDashboardContainer
    >
        <div
            style="width: 100%; height: 100%; position: relative"
            fxLayout="column"
        >
            <div id="ReportBudgetDesktop" fxLayout="column">
                <div
                    class="report-dashboard_desktop-component-section"
                    fxLayout="column"
                    style="z-index: 998"
                    [style.top]="previewMode ? '0' : '-159px'"
                    [style.position]="previewMode ? 'inherit' : 'sticky'"
                >
                    <app-report-header
                        [options]="report?.options"
                        [reportName]="report?.props?.name"
                        [company]="company"
                    ></app-report-header>
                    <div
                        [style.background-color]="
                            'var(--background-color-primary)'
                        "
                    >
                        <app-report-toolbar
                            [report]="report"
                            [options]="report?.options"
                            [company]="company"
                            [loading]="loading"
                            [scenarios]="report?.scenarios"
                            [budgets]="report?.budgets"
                            [projections]="report?.projections"
                            [dropdowns]="{
                                period: false,
                                comparation: false
                            }"
                            [dropdownConfigs]="{
                                period: {
                                    equalYear: true
                                },
                                comparation: {
                                    equalYear: false
                                }
                            }"
                            (handleChangePeriod)="onChangePeriod($event)"
                            (handleChangeComparation)="
                                onChangeComparation($event)
                            "
                            (handleResetPeriod)="handleResetPeriod.emit()"
                        ></app-report-toolbar>
                    </div>
                </div>

                <div
                    class="report-dashboard_desktop-component_section"
                    fxLayout="{{ chatNandaService.isOpen ? 'row' : 'column' }}"
                    [style]="
                        chatNandaService.isOpen
                            ? 'margin-right: 0px;position: relative;'
                            : ''
                    "
                >
                    <div
                        class="report-dashboard_desktop-component_section-column gap-16"
                        fxLayout="column"
                        fxFlex="{{
                            chatNandaService.isOpen && !previewMode
                                ? '65'
                                : '100'
                        }}"
                        [style.marginBottom]="'138px'"
                    >
                        @if (
                            !company?.isGroup && preferenceService?.viewBench
                        ) {
                            <dsn-expand-collapse
                                id="SectionBenchmarking"
                                [isExpanded]="
                                    sectionStates['SectionBenchmarking']
                                "
                                [customIcon]="
                                    'images/icons/benchmarking-icon.svg'
                                "
                                [label]="'Benchmarking'"
                                [type]="'default'"
                                [style.display]="
                                    hasBenchmarking ? 'block' : 'none'
                                "
                                [fontSize]="'large'"
                            >
                                <app-report-beachmarking-section
                                    [report]="report"
                                    [company]="company"
                                    [loading]="loading"
                                    [previewMode]="previewMode"
                                    (handleBenchmarkingDataLoaded)="
                                        onBenchmarkingDataLoaded($event)
                                    "
                                ></app-report-beachmarking-section>
                            </dsn-expand-collapse>
                        }

                        @if (preferenceService?.viewPeformance) {
                            <dsn-expand-collapse
                                id="SectionPerformance"
                                [isExpanded]="
                                    sectionStates['SectionPerformance']
                                "
                                [icon]="'fas fa-chart-line'"
                                [label]="'Performance'"
                                [type]="'default'"
                                (toggle)="
                                    toggleSection(
                                        $event,
                                        1,
                                        'SectionPerformance'
                                    )
                                "
                            >
                                @if (!loading) {
                                    <app-report-performance
                                        [visualizations]="report.visualizations"
                                        [options]="report.options"
                                        [report]="report"
                                        [company]="company"
                                        [previewMode]="previewMode"
                                    ></app-report-performance>
                                } @else {
                                    <div
                                        fxLayout="column"
                                        class="padding-12 gap-12"
                                    >
                                        <div
                                            fxLayout="row"
                                            fxLayoutAlign="center center"
                                            class="gap-12"
                                        >
                                            <dsn-skeleton-loader
                                                [type]="'circle'"
                                                [width]="'80px'"
                                                [height]="'80px'"
                                            ></dsn-skeleton-loader>
                                            <div
                                                fxLayout="column"
                                                class="gap-4"
                                            >
                                                @for (
                                                    item of [1, 2, 3, 4];
                                                    track item
                                                ) {
                                                    <dsn-skeleton-loader
                                                        [type]="'rectangle'"
                                                        [width]="'100px'"
                                                        [height]="'14px'"
                                                    ></dsn-skeleton-loader>
                                                }
                                            </div>
                                        </div>
                                        <dsn-skeleton-loader
                                            [type]="'rectangle'"
                                            [width]="'200px'"
                                            [height]="'20px'"
                                        ></dsn-skeleton-loader>
                                        <div fxLayout="row" class="gap-12">
                                            <dsn-skeleton-loader
                                                [type]="'rectangle'"
                                                [width]="'100px'"
                                                [height]="'34px'"
                                            ></dsn-skeleton-loader>
                                            <dsn-skeleton-loader
                                                [type]="'rectangle'"
                                                [width]="'100px'"
                                                [height]="'34px'"
                                            ></dsn-skeleton-loader>
                                        </div>
                                        <dsn-skeleton-loader
                                            [type]="'rectangle'"
                                            [width]="'100%'"
                                            [height]="'38px'"
                                        ></dsn-skeleton-loader>
                                        <dsn-skeleton-loader
                                            [type]="'rectangle'"
                                            [width]="'100%'"
                                            [height]="'38px'"
                                        ></dsn-skeleton-loader>
                                    </div>
                                }
                            </dsn-expand-collapse>
                        }

                        <dsn-expand-collapse
                            id="SectionIndicators"
                            [isExpanded]="sectionStates['SectionIndicators']"
                            [icon]="'fas fa-chart-line'"
                            [label]="'Indicadores'"
                            [type]="'transparent'"
                            [fontSize]="'large'"
                        >
                            <div fxLayout="column" class="gap-16">
                                <div
                                    fxLayout="column"
                                    class="budget-table-wrapper"
                                >
                                    <span
                                        class="text-14-semi-bold color-text-primary"
                                        >Orçamento</span
                                    >

                                    <app-table-budget
                                        [options]="report?.options"
                                        [loading]="loading"
                                        [company]="company"
                                    ></app-table-budget>
                                </div>
                            </div>
                        </dsn-expand-collapse>
                        @if (
                            !previewMode &&
                            contact?.props?._id !== "convidadoId"
                        ) {
                            <div fxLayout="column" fxLayoutAlign="start start">
                                <app-report-feedback
                                    [report]="report"
                                ></app-report-feedback>
                            </div>
                        }
                    </div>
                    @if (
                        !previewMode &&
                        contact?.props?._id !== "convidadoId" &&
                        chatNandaService.isOpen &&
                        preferenceService?.viewIA &&
                        accountingPlanService.features["IAEmployee"]
                    ) {
                        @defer (when !loading) {
                            <div
                                [hidden]="!chatNandaService.isOpen"
                                fxLayout="column"
                                class="report-dashboard_desktop-component_section-nanda"
                                fxFlex="35"
                            >
                                <app-nanda-chat
                                    fxLayout="column"
                                    style="height: 100%"
                                    fxFlex
                                    [report]="report"
                                ></app-nanda-chat>
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>

@if (
    !previewMode &&
    contact?.props?._id !== "convidadoId" &&
    !loading &&
    preferenceService?.viewIA &&
    accountingPlanService.features["IAEmployee"]
) {
    <app-nanda-icon (handleOpenChat)="onOpenChat()"></app-nanda-icon>
}
